import { useEffect, useRef } from 'react';

export const useGoogleCSE = () => {
  const cseLoaded = useRef(false);
  const containerRef = useRef(null);

  // Load Google CSE script once globally
  useEffect(() => {
    if (!cseLoaded.current && !window.google?.search?.cse) {
      const script = document.createElement('script');
      script.src = 'https://cse.google.com/cse.js?cx=17ab97e79478a4154';
      script.async = true;
      document.head.appendChild(script);
      cseLoaded.current = true;
    }
  }, []);

  // Create unique container for this instance
  const createSearchContainer = (containerId) => {
    if (containerRef.current && !containerRef.current.querySelector('.gcse-searchresults-only')) {
      const searchDiv = document.createElement('div');
      searchDiv.className = 'gcse-searchresults-only';
      searchDiv.id = containerId;
      containerRef.current.appendChild(searchDiv);
    }
  };

  // Extract results from a specific container
  const extractGoogleResults = (containerId) => {
    const container = document.getElementById(containerId);
    if (!container) return [];

    const results = [];
    const resultElements = container.querySelectorAll('.gsc-webResult');
    
    resultElements.forEach(element => {
      const titleElement = element.querySelector('.gs-title a, .gsc-title-link');
      const snippetElement = element.querySelector('.gs-snippet, .gsc-snippet');
      
      if (titleElement && snippetElement) {
        results.push({
          title: titleElement.textContent || titleElement.innerText,
          link: titleElement.href,
          snippet: snippetElement.textContent || snippetElement.innerText,
          source: 'google_cse'
        });
      }
    });
    
    return results;
  };

  // Trigger search in a specific container
  const triggerSearch = (query, containerId) => {
    const container = document.getElementById(containerId);
    if (!container) return;

    const searchInput = container.querySelector('.gsc-input input');
    if (searchInput) {
      searchInput.value = query;
      const searchButton = container.querySelector('.gsc-search-button input');
      if (searchButton) {
        searchButton.click();
      }
    }
  };

  return {
    containerRef,
    createSearchContainer,
    extractGoogleResults,
    triggerSearch
  };
};
